<template>
    <v-container >
      
      <v-text-field
          solo-inverted
          hide-details
          label="按时间搜索"
          prepend-inner-icon="search"
          v-model="search"
        ></v-text-field>
  
        <v-container fluid mt-4 >
            <div v-if="overlay" class="overlay">
                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div style="color: aliceblue; font-size: large; text-align: center;">
                        后台正在提取素材，需要1分钟左右。完成后自动加入直播切片列表。请稍候...
                        <br>(勿重复提交)
                    </div>
                    <v-btn @click="overlay = false">关闭</v-btn>
                </div>
            </div>
          <v-row>
            <v-col cols="4">
                    <v-list style="overflow-y:auto; height: 100vh;">
                    <v-list-item
                    v-for="(item, index) in filteredList"
                    :key="index"
                    @click="selectItem(item)"
                    :class="{ 'selected-item': item === selectedItem }"
                    >
                        <v-list-item-title>{{ item.account_name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.video_name }}</v-list-item-subtitle>
                        <v-list-item-subtitle>{{ new Date(item.shooting_time).toLocaleString('zh-CN') }}</v-list-item-subtitle>
                    </v-list-item>
                    </v-list>

            </v-col>
  
            <v-col cols="8" style="display: flex; justify-content: center; align-items: center; overflow-y:auto; ">
              <div v-if="selectedItem">
                <video
                  ref="videoPlayer"
                  @timeupdate="updateSubtitle"
                  style="max-height: 600px; max-width: 1000px;"
                  controls
                >
                <source
                            v-for="(url, index) in selectedItem.urls"
                            :key="index"
                            :src="url"
                            type="video/mp4" 
                        >
                </video>
                <div style="padding-top: 10px;">
                    <span>北京时间: <br>{{ beijing_time }}</span>
                </div>
                <v-form @keydown.left.prevent @keydown.right.prevent @keydown.space.prevent>
                <v-sheet>
                    <div style="float:left; min-width: 300px">
                    <v-text-field 
                        v-model="seekTime" 
                        label="按北京时间跳转" 
                        @keydown.enter="seekVideo"
                    ></v-text-field>
                    </div>
                    <div style="float: left; padding-left: 10px; padding-top: 10px;">
                    <v-btn @click="seekVideo">跳转</v-btn>
                    </div>
                </v-sheet>
                <v-sheet>
                    <div style="float:left; min-width: 100%">
                    <v-text-field 
                        v-model="clip_start" 
                        label="剪辑开始时间"
                        :rules="[value => !!value || '必填', value => !isNaN(Date.parse(value)) || '请填一个有效的时间']"
                    ></v-text-field>
                    <v-text-field 
                        v-model="clip_end" 
                        label="剪辑结束时间"
                        :rules="[value => !!value || '必填', value => !isNaN(Date.parse(value)) || '请填一个有效的时间']"
                    ></v-text-field>
                    <v-text-field v-model="commodity_name" label="商品名称（选填）"></v-text-field>
                    <v-textarea v-model="highlight" label="亮点描述（选填）"></v-textarea>
                    <v-btn @click="clipVideo">提取片段</v-btn>
                    </div>
                </v-sheet>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-container>
    </v-container>
  </template>
  
  <script>
    import { ref, reactive, onMounted, onBeforeUnmount, computed, nextTick } from 'vue'
    import axios from 'axios'
    import { BASE_URL } from '@/config.js'

    export default {
    setup() {
        const overlay = ref(false)
        const search = ref('')
        const videoPlayer = ref(null);
        const list = ref([]) // 这里应该从服务器获取直播的历史记录
        const selectedItem=ref(null)
        const seekTime=ref(0)
        const beijing_time = ref('')
        const clip_start = ref('')
        const clip_end = ref('')
        const commodity_name = ref('')
        const highlight = ref('')
        const clipVideo = () => {
            //先检查clip_start和clip_end是否是这种格式：2023/7/26 20:44:00
            //把clip_start转为Date对象
            //把clip_end转为Date对象
            //计算出相对时间
            //调用剪辑接口
            //剪辑接口返回成功后，刷新列表
            //剪辑接口返回失败后，提示用户
            try {
                var clip_start_time = new Date(clip_start.value)
                var clip_end_time = new Date(clip_end.value)
            } catch (error) {
                alert('剪辑开始时间和结束时间格式不正确，请填北京时间，格式为：2023/7/26 20:44:00')
                return
            }

            if (clip_start_time > clip_end_time){
                alert('剪辑开始时间不能大于剪辑结束时间')
                return
            }

            //检查剪辑开始时间和结束时间是否在直播时间范围内
            if (clip_start_time < new Date(selectedItem.value.shooting_time)){
                alert('剪辑开始时间不能小于直播开始时间')
                return
            }
            if (clip_end_time > new Date(selectedItem.value.shooting_time).setSeconds(new Date(selectedItem.value.shooting_time).getSeconds()+videoPlayer.value.duration)){
                alert('剪辑结束时间不能大于直播结束时间')
                return
            }

            var base_time = new Date(selectedItem.value.shooting_time)

            var start_time_in_second = (clip_start_time.getTime() - base_time.getTime()) / 1000
            var end_time_in_second = (clip_end_time.getTime() - base_time.getTime()) / 1000
            console.log(start_time_in_second, end_time_in_second)
            overlay.value = true //显示遮罩层            
            axios.post(BASE_URL + 'clip_raw_video/', {
                start_time_in_second: start_time_in_second,
                end_time_in_second: end_time_in_second,
                commodity_name: commodity_name.value,
                abstract: highlight.value,
                raw_video_id: selectedItem.value.video_id
            }).then(function (response) {
                overlay.value = false
                alert('片段提取成功')
                getKolRawVideoList()
            }).catch(function (error) {
                overlay.value = false
                alert('片段提取失败')
            })

        }

        

        const getKolRawVideoList = async () => {
            const response = await axios.get(BASE_URL + 'get_kol_raw_video_list/')
            list.value = response

            if (list.value.length > 0){
                selectItem(list.value[0])
                // console.log('list.value[0]', list.value[0])
                // selectedItem.value = list.value[0]
                // seekTime.value = new Date(selectedItem.value.file_ts).toLocaleString('zh-CN', { hour12: false })
                // beijing_time.value = new Date(selectedItem.value.file_ts).toLocaleString('zh-CN', { hour12: false })
            }
        }

        // onMounted(getKolRawVideoList)
        onMounted(() => {
            getKolRawVideoList()
            window.addEventListener('keydown', handleKeyDown);
        })

        onBeforeUnmount(() => {
            window.removeEventListener('keydown', handleKeyDown);
        })

        const handleKeyDown = (event) => {
            //空格键控制播放暂停
            // if (event.keyCode === 32) {
            //     event.preventDefault();
            //     if (videoPlayer.value.paused) {
            //         videoPlayer.value.play();
            //     } else {
            //         videoPlayer.value.pause();
            //     }
            // }

            //如果是按ctl+左键，则向前跳30秒
            if (event.keyCode === 37 && event.ctrlKey) {
                event.preventDefault();
                if (videoPlayer.value.currentTime >10) {
                    videoPlayer.value.currentTime -= 10;
                } else {
                    videoPlayer.value.currentTime = 0;
                }
            }

            //如果是按ctl+右键，则向后跳30秒
            if (event.keyCode === 39 && event.ctrlKey) {
                event.preventDefault();
                if (videoPlayer.value.currentTime < videoPlayer.value.duration - 10) {
                    videoPlayer.value.currentTime += 10;
                } else {
                    videoPlayer.value.currentTime = videoPlayer.value.duration;
                }
            }
        }

        const filteredList = computed(() => {
            if (search.value) {
                //Date.parse(search.value)之后，再加上一秒钟的时间，
                var t = Date.parse(search.value) + 1000
                
                if (isNaN(t)){
                    return list.value
                }

                //判断search.value是否只有日期的部分，没有时间的部分
                if (search.value.includes(':') == false){
                    //如果没有时间的部分，则把t设置为当天的最后一秒钟
                    var today = new Date()
                    t = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime()
                }

                return list.value.filter(item =>
                (Date.parse(item.shooting_time) <= t)
                // (item.live_room_name+item.owner_nick_name).toLowerCase().includes(search.value.toLowerCase())
                )
            } else {
                return list.value
            }
        })

        const selectItem = (item) => {
            selectedItem.value = item
            var t = Date.parse(search.value)
            if (isNaN(t)){
                seekTime.value = new Date(selectedItem.value.shooting_time).toLocaleString('zh-CN', { hour12: false })
            }else{
                seekTime.value = new Date(t).toLocaleString('zh-CN', { hour12: false })
            }
            
            nextTick(() => {
                if (videoPlayer.value){
                    videoPlayer.value.load()
                }
            })
            }

        const seekVideo = () => {
            if (videoPlayer.value){
                // 计算相对时间 seekTime.value 和 selectedItem.value.file_ts 的差值
                var start_ts = new Date(selectedItem.value.shooting_time);
                var end_ts = new Date(seekTime.value);
                var diff = (end_ts.getTime() - start_ts.getTime()) / 1000;
                if (diff < 0){
                    diff = 0
                }
                if (diff > videoPlayer.value.duration){
                    diff = videoPlayer.value.duration
                }
                videoPlayer.value.currentTime = diff
            }
            // videoPlayer.value.currentTime = seekTime.value
        }
        const updateSubtitle = () => {
            if (videoPlayer.value){
                //计算北京时间
                var start_ts = new Date(selectedItem.value.shooting_time);
                start_ts.setSeconds(start_ts.getSeconds()+videoPlayer.value.currentTime);
                beijing_time.value = start_ts.toLocaleString('zh-CN', { hour12: false });  
            }
        }

        return { videoPlayer, search, filteredList, selectItem, seekVideo, updateSubtitle,clipVideo,
             selectedItem,commodity_name,clip_start,clip_end, seekTime, highlight, beijing_time, overlay }
    }
    }
    </script>

<style scoped>
.selected-item {
  background-color: #eee; /* or any other color you like */
}
.overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }
</style>